import LZString from 'lz-string';

interface CompressDataProps {
  value: any;
  isParse?: boolean;
}

export const compressData = ({ value, isParse = true }: CompressDataProps) => {
  try {
    return LZString.compressToEncodedURIComponent(isParse ? JSON.stringify(value) : value);
  } catch (error) {
    console.error('Error compressing data:', error);
    // Return the original value if compression fails
    return isParse ? JSON.stringify(value) : value;
  }
};

export const decompressData = ({ value, isParse = true }: CompressDataProps) => {
  try {
    if (!value) return null;
    
    const originalData = LZString.decompressFromEncodedURIComponent(value);
    
    if (!originalData) {
      // If decompression returns null, try using the original value
      return isParse ? JSON.parse(value) : value;
    }

    return isParse ? JSON.parse(originalData) : originalData;
  } catch (error) {
    console.error('Error decompressing data:', error);
    // Return the original value if decompression or parsing fails
    return value;
  }
};